module.exports = __webpack_public_path__ + "media/applicants/header2-e6517a02.jpg";